module.exports = __webpack_public_path__ + "static/media/CineCost.c8639006.png";